module.exports = __webpack_public_path__ + "banquet/components/InventoryRecordDetail/images/heart_filled_highlight.ff361233244b0ac0fd18f2dc8a37d5c1.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordDetail/images/heart_filled_highlight.svg
// module id = 1672
// module chunks = 1